import {
  BarChart,
  CreditCard,
  Description,
  GridView,
  InfoOutlined,
} from '@mui/icons-material'
import { translate } from 'locales'
import React from 'react'
import * as S from './styles'

export type FinancialTabKey =
  | 'overview'
  | 'monthlyHistory'
  | 'invoices'
  | 'information'
  | 'bankData'

interface FinancialTabsProps {
  activeTab: FinancialTabKey
  onChange: (tab: FinancialTabKey) => void
}

const FinancialTabs = ({ activeTab, onChange }: FinancialTabsProps) => {
  const tabs: { key: FinancialTabKey; label: string; icon: JSX.Element }[] = [
    {
      key: 'overview',
      label: translate('financial.tabs.overview'),
      icon: <GridView />,
    },
    {
      key: 'monthlyHistory',
      label: translate('financial.tabs.monthlyHistory'),
      icon: <BarChart />,
    },
    {
      key: 'invoices',
      label: translate('financial.tabs.invoices'),
      icon: <Description />,
    },
    {
      key: 'information',
      label: translate('financial.tabs.information'),
      icon: <InfoOutlined />,
    },
    {
      key: 'bankData',
      label: translate('financial.tabs.bankData'),
      icon: <CreditCard />,
    },
  ]

  return (
    <S.TabsList role="tablist">
      {tabs.map((tab) => (
        <S.TabButton
          key={tab.key}
          type="button"
          role="tab"
          aria-selected={activeTab === tab.key}
          className={activeTab === tab.key ? 'active' : undefined}
          onClick={() => onChange(tab.key)}
        >
          {tab.icon}
          {tab.label}
        </S.TabButton>
      ))}
    </S.TabsList>
  )
}

export default FinancialTabs
